import React, { useContext, useEffect, useState } from "react";

import PageTitle from "./Typography/PageTitle";
import CTA from "./CTA";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@windmill/react-ui";
import { context } from "../App";
import { userConfig } from "../auth/use.cache";
import { LinkIcon } from "../icons";
import { backgroundColor, borderColor } from "tailwindcss/defaultTheme";

function Modals() {
  const {
    modal,
    setModal,
    setAlert,
    itIsFirstTime,
    setItIsFirstTime,
  } = useContext(context);
  const [user, setUser] = useState(userConfig.user);
  const useDevSensor = localStorage.getItem("useDevSensor");
  const [nextMessage, setNextMessage] = useState(0);
  const [ devsensorIdIsCopied, setDevsensorIdIsCopied ] = useState(false);

  function openModal() {
    setModal((prevModal) => ({
      ...prevModal,
      isOpen: !prevModal.isOpen,
    }));
  }

  function closeModal() {
    if (!useDevSensor) {
      localStorage.setItem("useDevSensor", true);
    }
    setModal((prevModal) => ({
      ...prevModal,
      isOpen: !prevModal.isOpen,
    }));
  }

  const copyDevsensor_id = (devId) => {
    navigator.clipboard
      .writeText(devId)
      .then(() => {
        setDevsensorIdIsCopied(true);
        setAlert((prevModal) => ({
          ...prevModal,
          isOpen: true,
          message: "DevSensor Id copied",
          decription: ".",
          type: "green",
        }));
      })
      .catch((err) => {
        console.error("Unable to copy text: ", err);
        setAlert((prevModal) => ({
          ...prevModal,
          isOpen: true,
          message: err,
          decription: ".",
          type: "red",
        }));
        setDevsensorIdIsCopied(false);
      });
  };

  const welcomeMessage = [
    {
      message: (
        <p>
          Hello <span className="font-bold">{user?.username || ""}</span>,
          welcome to DevSensor, where we assist you in maintaining good health
          while enhancing productivity. To use the dashboard, ensure you possess
          a
          <a
            target="_blank"
            href="https://devsensor.axgura.com"
            className="text-link p-1 cursor-pointer"
          >
            DevSensor device
          </a>
        </p>
      ),
    },
    {
      message: (
        <p>
          Copy your {"DevSensorID: "}
          <span className="font-bold text-link">
            <span
              onClick={() => copyDevsensor_id(user?.devsensor_id)}
              className=" cursor-pointer"
            >
              {user?.devsensor_id || "DevSensorID, get it in your profile"}{" "}
              <span className="ml-0">{devsensorIdIsCopied?<>(copied!)</>:<>(click to copy)</>}</span>
            </span>
          </span>
          {/* {" "} You can always get your DevSensorID from your profile. */}
        </p>
      ),
    },
    {
      message: (
        <p>
          Once you have the device, power it on, go to your PC's WIFI settings,
          and connect to "DevSensor Pro" WIFI.
        </p>
      ),
    },
    {
      message: (
        <p>
          Once connected, navigate to
          <a
            target="_blank"
            href="http://192.168.4.1/"
            className="text-link p-1 cursor-pointer"
          >
            http://192.168.4.1/
          </a> <br /><br />
          Make sure you're connected to "DevSensor Pro" <br /><br />
          If you have not copied your DevSensorID here's it: {" "}
          <span
              onClick={() => copyDevsensor_id(user?.devsensor_id)}
              className="cursor-pointer flex text-link"
            >
              {user?.devsensor_id || "DevSensorID, get it in your profile"}{" "}
              <span className="ml-0 text-bold">{devsensorIdIsCopied?<>(copied!)</>:<>(click to copy)</>}</span>
            </span>
            {" "} You can always get your DevSensorID from your profile.
        </p>
      ),
    },
    {
      message: <p>Enter an internet enabled WiFi NAME/SSID and Password.</p>,
    },
    {
      message: (
        <p>
          After completing these steps, you're good to go!.
          If you have any issue 
          <a
            target="_blank"
            href="https://www.canva.com/design/DAGEMa4OsEc/KLNzy1E6hBzYn_mbM5_Z6w/view?utm_content=DAGEMa4OsEc&utm_campaign=designshare&utm_medium=link&utm_source=editor"
            className="text-link cursor-pointer p-2 text-center"
          >
            View our manual for more details
          </a>
        </p>
      ),
    },
  ];


  useEffect(() =>{
    if(modal && !modal.firstTime){
      setItIsFirstTime(false);
    }
  },[modal])

  return (
    <>
      {modal && (
        <Modal
          style={{
            background: "white",
            color: "black",
            border: "2px solid gray",
            borderButtom: "none",
          }}
          isOpen={modal.isOpen}
          onClose={closeModal}
        >
          <ModalHeader style={{ color:"black" }}>
            {!itIsFirstTime ? (
              <>{modal.message}</>
            ) : (
              <>
                {(welcomeMessage.length - nextMessage) !== (welcomeMessage.length) ? "" : "Welcome to DevSensor" }
              </>
            )}
          </ModalHeader>
          {!itIsFirstTime ? (
            <>
              <ModalBody>{modal.description}</ModalBody>
            </>
          ) : (
            <>
              <ModalBody style={{ color: "black" }}>
                {welcomeMessage[nextMessage]?.message || ""}
              </ModalBody>
            </>
          )}
          <ModalFooter style={{ background: "white", color: "black" }}>
            <div className="hidden sm:block">
              {!itIsFirstTime ? (
                <>
                  <Button
                    block
                    size="large"
                    layout="outline"
                    onClick={closeModal}
                    style={{ color:"black", borderColor: "black" }}
                  >
                    Okay
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    block
                    size="large"
                    layout="outline"
                    style={{ color:"black", borderColor: "black" }}
                    onClick={() => {
                      if (welcomeMessage.length - 1 == nextMessage) {
                        setNextMessage(0);
                      } else {
                        setNextMessage(nextMessage + 1);
                      }
                    }}
                  >
                    {welcomeMessage.length - nextMessage !== 1 ? (
                      <>Next ({welcomeMessage.length - nextMessage})</>
                    ) : (
                      <>Okay</>
                    )}
                  </Button>
                </>
              )}
            </div>

            {modal.link.length > 4 && (
              <div className="hidden sm:block">
                <a href={modal.link}>
                  <Button>{modal.btnTxt}</Button>
                </a>
              </div>
            )}

            <div className="block w-full sm:hidden">
              {!itIsFirstTime ? (
                <>
                  <Button
                    block
                    size="large"
                    layout="outline"
                    style={{ color:"black", borderColor: "black" }}
                    onClick={closeModal}
                  >
                    Okay
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    block
                    size="large"
                    layout="outline"
                    style={{ color:"black", borderColor: "black" }}
                    onClick={() => {
                      if (welcomeMessage.length - 1 == nextMessage) {
                        setNextMessage(0);
                      } else {
                        setNextMessage(nextMessage + 1);
                      }
                    }}
                  >
                    {welcomeMessage.length - nextMessage !== 1 ? (
                      <>Next ({welcomeMessage.length - nextMessage})</>
                    ) : (
                      <>Okay</>
                    )}
                  </Button>
                </>
              )}
            </div>

            {modal.link.length > 4 && (
              <div className="block w-full sm:hidden">
                <a href={modal.link}>
                  <Button block size="large" style={{ color:"black", borderColor: "black", backgroundColor: "transparent" }}>
                    {modal.btnTxt}
                  </Button>
                </a>
              </div>
            )}
          </ModalFooter>
        </Modal>
      )}
    </>
  );
}

export default Modals;
